import { FC } from 'react';

import PageProps from '../PageProps';
import Component from './component';

const BeneficiariesDocsIntro: FC<PageProps> = ({ setCurrentPage }) => (
  <Component onNavigate={() => setCurrentPage('beneficiaries-docs')} />
);

export default BeneficiariesDocsIntro;
